export enum GrupoContacto {
	firmaOperador,
	referenteComercial,
	referenteGestion,
	referenteTecnico,
	ruteador
}